import React from 'react';
export const HostContext = /*#__PURE__*/React.createContext(undefined);
export const HostProvider = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    host
  } = _ref;
  return /*#__PURE__*/React.createElement(HostContext.Provider, {
    value: host
  }, children);
});
export function useHost() {
  const context = React.useContext(HostContext);
  if (context === undefined) {
    throw new Error('useHost must be used within a HostProvider');
  }
  return context;
}
//# sourceMappingURL=host-context.js.map